import React, { useState } from 'reactn'
import { Box, HStack, Image } from "@chakra-ui/react"

const Widgets = ({ score, hideFunction }) => {
  return (
    <HStack width="90%"  height="100%">
      <Box id="widget1" marginLeft={['0px', '0px', '5px', '10px']} marginRight={['0px', '0px', '5px', '10px']}>
        <Image
          alt="Dayrize Score Widget 1"
          src={`/sustainability/${score}/widget1.jpg`}
          onError={(event) => hideFunction()}
        />
      </Box>
      <Box id="widget2" marginLeft={['0px', '0px', '0px', '00px']} marginRight={['0px', '0px', '5px', '5px']}>
        <Image
          alt="Dayrize Score Widget 1"
          src={`/sustainability/${score}/widget2.jpg`}
          onError={(event) => hideFunction()}
        />
      </Box>
      <Box id="widget3" marginLeft={['px', '0px', '0px', '0px']} marginRight={['0px', '0px', '5px', '00px']}>
        <Image
          alt="Dayrize Score Widget 1"
          src={`/sustainability/${score}/widget3.jpg`}
          onError={(event) => hideFunction()}
        />
      </Box>  
    </HStack>

    

  )
}

export default Widgets

